export default __webpack_public_path__ + "static/Staatliches-Regular-22f2e7892d3986aa2ef853a8910a7b57.woff2";